'use client'
import { useParams } from 'next/navigation'
import styled from 'styled-components'
import { MODALS } from '@/context'
import { useModal } from '@/hooks'
import { useTranslator } from '@/hooks'
import type { TypeLang } from '@/utils'
import { vw, mq, getP16 } from '@/styles'
import { Logo, Burger, LinkStyled, Link, Figure } from '@/components'
import { Dropdown } from '@/components'

const mediaTiktok = {
  type: 'svg' as const,
  alt: 'TikTok logo',
  src:'/images/svg/i--tiktok.svg',
  size: { width: 24, height: 24 }
}
const arrayOptions = [
  {value: 'ES', path:'/'},
  {value: 'CAT', path:'/cat'},
  {value: 'EN', path:'/en'},
  {value: 'FR', path:'/fr'}
]

export const Navbar = () => {
  const { isActive:isActiveModalMenu, toggle: toggleModalMenu } = useModal(MODALS.MENU)
  const { lang } = useParams() as { lang: TypeLang }

  const { t } = useTranslator()

  return (
    <Nav $menuOpen={isActiveModalMenu}>
      <Logo name={'corso'}/>
      <Burger onClick={toggleModalMenu} menuOpen={isActiveModalMenu} />
      <Wrapper>
        <LinkStyled href={'https://dynameatpro.blob.core.windows.net/iluzione/f6ddda49-a764-4df7-ab69-064cca37d937/4c68f1d9-bc0b-49a0-bd36-3ec2c19fe464/index.html#/?zone=65a8fd2a-923a-495c-af59-2385779cf5d5&avoidRedirect=true'}target='_blank' rel='noopener noreferrer' outline>{t('layout.main.menu')}</LinkStyled>
        <LinkStyled href={`https://wa.me/c/${t('layout.footer.phone_link')}`} outline> {t('layout.main.whatsapp')}</LinkStyled>
        <Link href='https://www.tiktok.com/@iluzione_restaurant' className='tiktok'>
          <Figure media={mediaTiktok}/>
        </Link>
        <Dropdown className='detail-dropdown' trigger={lang.toUpperCase()} options={arrayOptions} direction={'down'} />
      </Wrapper>
    </Nav>
  )
}

const Nav = styled.nav<{ $menuOpen?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: row;
  grid-column: 1 / span 6;
  height:${vw(90, 'mobile')};
  justify-content: space-between;
  left: 0;
  padding:${vw(15, 'mobile')} ${vw(17, 'mobile')};
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;

  /* MOBILE LANDSCAPE */
  @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {
    height: 78px;
    padding: 15px 17px;

    > .logo {
      figure {
        height: 28px;
        width: 207px;
      }
    }

    > button {
      width: 60px;

      &,
      figure {
        height: 60px;
        width: 60px;
      }
    }
    ${mq.lessThan('tablet')} {
      background-color: ${({ $menuOpen }) => $menuOpen ? 'var(--color-dark--green)' : 'transparent'};
    }
  }


  ${mq.greaterThan('nexus7')} {
    padding: 21.812px 24.720px;
  }

  ${mq.greaterThan('tablet')} {
    grid-column: 9 / span 2;
    height:${vw(78, 'desktop')};
    padding:${vw(25, 'desktop')} ${vw(50, 'desktop')};
  }

  ${mq.greaterThan('container')} {
    padding: 20.295px 40.590px;
    height: 63.32px;
  }

`

const Wrapper = styled.div`
  display: none;

  ${mq.greaterThan('tablet')} {
    align-items: center;
    display: flex;
    flex-direction: row;
  }

  > a:not(.tiktok) {
    height: ${vw(39, 'mobile')};
    padding: ${vw(10, 'mobile')} ${vw(20, 'mobile')};
    margin-right: unset;

    ${mq.greaterThan('tablet')} {
      margin-right: ${vw(20, 'desktop')};
      height:${vw(39, 'desktop')};
      padding: ${vw(10, 'desktop')} ${vw(20, 'desktop')};
    }

    ${mq.greaterThan('container')} {
      margin-right: 16.236px;
      height: 31.66px;
      padding: 8.18px 16.236px;
    }

    div:last-of-type {
      ${getP16}

      @media screen and (min-width: 768px) and (max-width: 1170px) {
        font-size: 15.5px;
      }
      ${mq.greaterThan('container')} {
        font-size: 16px;
      }
    }

  }
  .tiktok{
    figure {
      display: none;
      ${mq.greaterThan('tablet')} {
        display:block;
        height: ${vw(28, 'desktop')};
        margin-right: ${vw(20, 'desktop')};
        width: ${vw(28, 'desktop')};
      }

      ${mq.greaterThan('container')} {
        display:block;
        height: 22.72px;
        margin-right: 16.2px;
        width: 22.72px;
      }
    }
  }

`
